import styled from "styled-components";

export const DetailVacancyMobileWrapp = styled.section`
  margin-top: 64px;
  min-height: 100vh;
  background: #f7f5f0;
  padding: 32px 0;

  .content-description {
    width: min(100% - 32px, 720px);
    margin: 0 auto;
    padding: 22px;
    background: #ffffff;
    border: 1px solid #e7e2d8;
    border-radius: 8px;
    color: #28342f;

    .logo-company img {
      width: 48px;
      max-height: 48px;
      object-fit: contain;
    }

    .section-title {
      font-size: 17px;
      margin: 18px 0 8px;
      color: #17201b;
    }

    .company-profile p,
    .section-describe {
      font-size: 14px;
      color: #4d5550;
      line-height: 1.6;
      text-align: left;
    }

    .section-describe li {
      margin-bottom: 6px;
    }

    .link-register {
      margin-top: 24px;

      button {
        min-width: 150px;
        height: 38px;
        border: none;
        border-radius: 8px;
        text-align: center;
        cursor: pointer;
        font-weight: 700;
        background: #28342f;

        a {
          color: white;
        }
      }
    }
  }
`
